module.exports = __webpack_public_path__ + "static/media/Download-appstore.8bef711f.svg";